import React from 'react';
import { UnverifiedTable } from './components/UnverifiedTable/UnverifiedTable';
import { VerifiedTable } from './components/VerifiedTable';
import { UserExperienceDto } from '@apply/api/src/api/ApplyApi';

export interface NonBFIPanelProps {
    unverifiedExperience: UserExperienceDto[];
    verifiedExperience: UserExperienceDto[];
}

export const NonBFIPanel: React.FC<NonBFIPanelProps> = ({ unverifiedExperience, verifiedExperience }) => {
    return (
        <>
            <UnverifiedTable experiences={unverifiedExperience} />
            <br />
            <br />
            <VerifiedTable experiences={verifiedExperience} />
        </>
    );
};
